export default {
	name: 'workshopObject', // Rename to avoid conflict
	title: 'Workshop',
	type: 'object',
	fields: [
		{
			name: 'title',
			title: 'Title',
			type: 'string',
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'slug',
			title: 'Slug',
			type: 'slug',
			options: {
				source: 'title',
				maxLength: 96,
			},
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'description',
			title: 'Description',
			type: 'text',
		},
		{
			name: 'date',
			title: 'Date & Start time',
			type: 'datetime',
			description:
				'This will be used to extract day, month, year and time information',
		},
		{
			name: 'time',
			title: 'Display Time',
			type: 'string',
			description: 'E.g., "10:00 AM - 12:00 PM"',
		},
		{
			name: 'duration',
			title: 'Duration (Hours)',
			type: 'number',
		},
		{
			name: 'location',
			title: 'Location',
			type: 'string',
		},
		{
			name: 'variant',
			title: 'Visual Variant',
			type: 'string',
			options: {
				list: [
					{ title: 'Light', value: 'light' },
					{ title: 'Dark', value: 'dark' },
				],
			},
			initialValue: 'light',
		},
		{
			name: 'isVirtual',
			title: 'Virtual Workshop',
			type: 'boolean',
		},
		{
			name: 'price',
			title: 'Price',
			type: 'string',
			description: 'E.g., "R350" or "Free"',
		},
		{
			name: 'ifFree',
			title: 'Free Entry',
			type: 'boolean',
		},
		{
			name: 'limit',
			title: 'Limit',
			type: 'number',
			description: 'Number of available seats (0 means fully booked)',
		},
		{
			name: 'image',
			title: 'Image',
			type: 'image',
			options: {
				hotspot: true,
			},
		},
		{
			name: 'calendarIconUrl',
			title: 'Calendar Icon URL',
			type: 'url',
		},
		{
			name: 'registrationLink',
			title: 'Registration Link',
			type: 'url',
		},
		{
			name: 'isFeatured',
			title: 'Is Featured',
			type: 'boolean',
			initialValue: false,
		},
		{
			name: 'content',
			title: 'Workshop Content (Description)',
			type: 'array',
			of: [
				{ type: 'block' },
				{
					type: 'image',
					options: { hotspot: true },
				},
			],
		},
		{
			name: 'benefits',
			title: 'Benefits',
			type: 'array',
			of: [{ type: 'string' }],
			description: 'List of benefits for workshop attendees',
		},
	],
};
